import React from 'react'
import Box from '../../components/shared/ui/box'
import EventDetails from './eventDetails'
import Col from '../../components/shared/ui/col'
import Row from '../../components/shared/ui/row'
import Text from '../../components/shared/ui/text'
import Moment from 'moment'
import { MdAddCircle } from 'react-icons/md'
import { MdRemoveCircle } from 'react-icons/md'
import ReactHtmlParser from 'react-html-parser'

class EventsDisplayItem extends React.Component<any, any> {
  handleShowDetailsClick(event, e) {
    if (
      this.props.details.hasOwnProperty('seqn') &&
      this.props.details.seqn === event.seqn
    ) {
      this.props.onShowDetails(null)
    } else {
      this.props.onShowDetails(event)
    }
  }

  render() {
    return (
      <Box>
        {this.props.data.map((event, index) => {
          return (
            <div
              key={index}
              onClick={this.handleShowDetailsClick.bind(this, event)}
            >
              <Box>
                <Row
                  css={{ marginBottom: '1em' }}
                  items="stretch"
                  content="center"
                  contentExtraSpace="center"
                >
                  <Col
                    size={1}
                    align="center"
                    css={{
                      backgroundColor: '#c8c8c8',
                      color: '#646464',
                      padding: '1em',
                      borderRight: '10px solid white'
                    }}
                  >
                    <Row items="center" content="center">
                      <Text
                        css={{
                          fontWeight: 'bold',
                          fontSize: '1.1em !important',
                          textAlign: 'center',
                          margin: '0 !important',
                          padding: '0 !important'
                        }}
                      >
                        {event.is_ongoing === true
                          ? ''
                          : Moment(event.start_date).format('DD')}
                      </Text>
                    </Row>
                  </Col>
                  <Col
                    size={10}
                    align="center"
                    css={{
                      textAlign: 'left',
                      backgroundColor: '#f0f0f0',
                      color: '#646464',
                      padding: '1em'
                    }}
                  >
                    <Text css={{ fontSize: '1.1em !important' }}>
                      {ReactHtmlParser(event.name)}
                    </Text>
                  </Col>
                  <Col
                    size={1}
                    align="center"
                    css={{
                      backgroundColor: '#f0f0f0',
                      color: '#646464',
                      padding: '1em',
                      textAlign: 'center',
                      ' svg': { fontSize: '1.7em', color: '#a8a7a7' }
                    }}
                  >
                    <Row items="center" content="center">
                      {this.props.details.hasOwnProperty('seqn') &&
                      this.props.details.seqn === event.seqn ? (
                        <MdRemoveCircle />
                      ) : (
                        <MdAddCircle />
                      )}
                    </Row>
                  </Col>
                </Row>
              </Box>
              {this.props.details.hasOwnProperty('seqn') &&
              this.props.details.seqn === event.seqn ? (
                <EventDetails
                  onCloseEventDetails={this.props.onCloseDetails}
                  {...event}
                />
              ) : (
                <div />
              )}
            </div>
          )
        })}
      </Box>
    )
  }
}

export default EventsDisplayItem
